<script lang="ts">
	import createCalendar from '$lib/components/DatePicker/calendar';
	import { onMount, tick } from 'svelte';
	import { _ } from 'svelte-i18n';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import type { Instance } from 'flatpickr/dist/types/instance';
	import Button from '$lib/components/Button/Button.svelte';
	import { getHubStores } from '$lib/stores/hubStores';

	const { hub } = getHubStores();

	export let date: Date | string = new Date();
	export let isScheduled = false;
	let target: HTMLElement;
	let calendar: Instance;

	let buttons: HTMLDivElement;
	let isReady = false;
	onMount(async () => {
		await tick();
		if (target) {
			calendar = createCalendar({
				lang: $hub.locale,
				target,
				time: true,
				minDate: new Date(),
				defaultDate: date,
				onReady(_, __, fp) {
					fp.calendarContainer.append(buttons);
					isReady = true;
				},
				onClose: () => {
					date = calendar.selectedDates[0];
				},
			});
		}
	});
	const save = () => {
		isScheduled = true;
		calendar.close();
	};
	const unSchedule = () => {
		isScheduled = false;
		calendar.close();
	};
</script>

<div bind:this={target} class="scheduler" aria-label={$_('common.schedule')}>
	<Button displayType={isScheduled ? 'primary' : 'secondary'} size="small">
		<div class="scheduleButton">
			{#if isScheduled}
				<div class="dot" />
			{/if}
			<Icon icon="time" size="24" color="white" clickable />
		</div>
	</Button>
</div>

<input type="hidden" name="isScheduled" bind:value={isScheduled} />
<input type="hidden" name="scheduledDate" bind:value={date} />

<div class="buttons" class:hidden={!isReady} bind:this={buttons}>
	<Button displayType="secondary" on:click={unSchedule}>
		{#if isScheduled}
			{$_('hubs.newsletters.unschedule')}
		{:else}
			{$_('common.cancel')}
		{/if}
	</Button>
	<Button on:click={save} displayType="primary">{$_('compose.schedule')}</Button>
</div>

<style>
	.buttons {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		padding: var(--gutterSmall);
		background-color: white;
	}

	.scheduleButton {
		position: relative;
	}

	.dot {
		position: absolute;
		block-size: 7px;
		inline-size: 7px;
		border-radius: 50%;
		background-color: red;
		inset-block-start: 1px;
	}

	.hidden {
		display: none;
	}
</style>
